export const AGE_HUB = {
    label: 'Age Calculator',
    path: '/age/',
}

export const AGE_SPOKES = [
    { label: 'Chronological Age', path: '/chronological-age-calculator/' },
    { label: 'Pet Age', path: '/pet-age-calculator/' },
    { label: 'Eligibility Check', path: '/eligibility-calculator/' },
    { label: 'Generation Finder', path: '/generation-calculator/' },
    { label: 'Islamic Age', path: '/islamic-age-calculator/' },
    { label: 'Retirement Age', path: '/retirement-age-calculator/' },
]